import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private userSubject: BehaviorSubject<any>;
  public user: Observable<any>;

  constructor(private router: Router, private http: HttpClient) {
    const storedUser = localStorage.getItem('user');
    this.userSubject = new BehaviorSubject<any>(
      storedUser ? JSON.parse(storedUser) : null
    );
    this.user = this.userSubject.asObservable();
  }

  public get userValue() {
    return this.userSubject.value;
  }

  login(username: string, password: string) {
    return this.http
      .post<any>(
        `${environment.apiUrl}/login`,

        new URLSearchParams({
          username: username,
          password: password,
        }),

        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          },
        }
      )
      .pipe(
        map((user) => {
          // // console.log('user on login', user);
          // store user details and jwt token in local storage to keep user logged in between page refreshes

          localStorage.setItem('user', JSON.stringify(user));
          this.userSubject.next(user);
          // this.startRefreshTokenTimer();
          return user;
        })
      );
  }

  logout() {
    // LoginComponent.ngOnInit() calls logout() unconditionally on every visit
    // to the login page, including when no one was logged in. Only do the
    // heavier cleanup below when there was an actual session to tear down,
    // otherwise the reload below would fire on every login page load.
    const wasLoggedIn = !!this.userSubject.value;

    // remove user from local storage to log user out
    // todo: add revoke token endpoint if possible
    // this.stopRefreshTokenTimer();
    localStorage.removeItem('user');
    // Also clear per-vehicle/per-session state left by other services, so it
    // doesn't leak into the next account that logs in on this browser.
    localStorage.removeItem('selectedVehicle');
    localStorage.removeItem('technical_records_filter_state');

    this.userSubject.next(null);
    this.router.navigate(['/login']);

    if (wasLoggedIn) {
      // Force a full reload so root-scoped services (VehiclesService's
      // selectedVehicle and its vehicles$/archivedVehicles$ caches, etc.)
      // are torn down rather than surviving in memory for the next login
      // on this tab.
      window.location.reload();
    }
  }

  // refreshToken() {
  //   let formData = new FormData();
  //   // console.log('refreshing token');

  //   let userNew = JSON.parse(localStorage.getItem('user') || '{}');

  //   // console.log('user on refresh', userNew);

  //   // this.userSubject.next(userNew);
  //   let data: any = {
  //     refresh: userNew.refresh,
  //   };

  //   // data = JSON.stringify(data);

  //   formData.append('refresh', userNew.refreshToken);

  //   return this.http
  //     .post<any>(`${environment.apiUrl}/auth/jwt/refresh/`, data, {
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .pipe(
  //       map((user) => {
  //         // // console.log('user', user);
  //         let userNew = { ...user, refresh: this.userValue.refreshToken };
  //         // user.refresh = this.userValue.refreshToken;
  //         // // console.log('user on refresh', userNew);
  //         // store user details and jwt token in local storage to keep user logged in between page refreshes
  //         localStorage.setItem('user', JSON.stringify(userNew));
  //         this.userSubject.next(userNew);

  //         this.startRefreshTokenTimer();
  //         return user;
  //       })
  //     );
  // }

  // private refreshTokenTimeout?: NodeJS.Timeout;

  // private startRefreshTokenTimer() {
  //   // parse json object from base64 encoded jwt token
  //   // console.log(this.userValue);
  //   const jwtToken = JSON.parse(
  //     atob(this.userValue.access.split('.')[1])
  //   ) as any;

  //   // set a timeout to refresh the token a minute before it expires
  //   const expires = new Date(jwtToken.exp * 1000);
  //   // console.log('expires', (expires.getTime() - Date.now()) / 1000);

  //   const timeout = expires.getTime() - Date.now() - 60 * 1000;
  //   // console.log('timeout', timeout);
  //   this.refreshTokenTimeout = setTimeout(
  //     () => this.refreshToken().subscribe(),
  //     1000
  //     // timeout
  //   );
  // }

  // private stopRefreshTokenTimer() {
  //   clearTimeout(this.refreshTokenTimeout);
  // }
}
